module.exports = "https://cdn.thelire.com/ins/resource/icon_line_back.0b35ae995a5ef7eeb46655a6ed469fbf.png";